import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Our Bestsellers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1011"
          img={bestSellerOne}
          productName="Flower Base"
          color="Black and White"
          badge={true}
          des="Elegant flower vase perfect for home decoration."
        />
        <Product
          _id="1012"
          img={bestSellerTwo}
          productName="New Backpack"
          color="Gray"
          badge={false}
          des="Durable and stylish backpack for daily use."
        />
        <Product
          _id="1013"
          img={bestSellerThree}
          productName="Household Materials"
          color="Mixed"
          badge={true}
          des="Essential household items to simplify your chores."
        />
        <Product
          _id="1014"
          img={bestSellerFour}
          productName="Travel Bag"
          color="Black"
          badge={false}
          des="Spacious travel bag for your trips and adventures."
        />
      </div>
    </div>
  );
};

export default BestSellers;
